import { render, staticRenderFns } from "./kdPostscript.vue?vue&type=template&id=4af623f2&scoped=true"
import script from "./kdPostscript.vue?vue&type=script&lang=js"
export * from "./kdPostscript.vue?vue&type=script&lang=js"
import style0 from "./kdPostscript.vue?vue&type=style&index=0&id=4af623f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af623f2",
  null
  
)

export default component.exports